import { Card, CardContent } from "@/components/ui/card"
import { kpis, categories, valueOverTime } from "../-data/fixtures"
import { ChartContainer } from "@/components/ui/chart"
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts"

export default function AvgPrescriptionValue() {
  return (
    <Card className="rounded-2xl col-span-1">
      <CardContent className="p-4">
        <div className="flex items-center">
          <div>
            <div className="text-xs text-muted-foreground">Average prescription value</div>
            <div className="text-2xl font-semibold flex items-center gap-2">
              {kpis.avgPrescriptionValue.currency} {kpis.avgPrescriptionValue.value.toFixed(2)}
              <span className="text-green-600 text-xs">↗ {kpis.avgPrescriptionValue.deltaPct}%</span>
            </div>
          </div>
        </div>
        <div className="mt-3 space-y-1">
          {categories.avgValueByMode.map((c, i) => (
            <div key={i} className="flex items-center justify-between text-sm">
              <span>{c.label}</span>
              <div className="flex items-center gap-2">
                <span className="tabular-nums">AED {c.value.toFixed(2)}</span>
                <span className={`${c.deltaPct >= 0 ? "text-green-600" : "text-red-600"} text-xs`}>
                  {c.deltaPct >= 0 ? "↗" : "↘"} {Math.abs(c.deltaPct)}%
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-3">
          <div className="text-sm text-black mb-1">Value over time</div>
          <ChartContainer config={{ value: { label: "Value", color: "#2aa198" } }} className="w-full h-56 aspect-auto">
            <BarChart data={valueOverTime}>
              <CartesianGrid vertical={false} />
              <XAxis dataKey="month" tickLine={false} axisLine={false} />
              <YAxis hide />
              <Bar dataKey="value" fill="var(--color-value)" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ChartContainer>
        </div>
      </CardContent>
    </Card>
  )
}